import React from "react";
import styled from "styled-components";
const cdn_url = process.env.REACT_APP_CDN_API_SERVER_URL;
const CsTel = `${cdn_url}/assets/version-2/main/CsTel.svg`;

export default function HomeCsTel() {
  return (
    <CsTelBox>
      <img src={CsTel} alt="상담사" />
      <CsHelpText>
        <p>도움이 필요하시다면</p>
        <p>언제든 연락주세요</p>
      </CsHelpText>
      <CsTelText>
        <TextP1 href="tel:1544-9664">1544 9664</TextP1>
        <TextP2>평일 09:00 ~ 18:00 주말 및 공휴일 휴일</TextP2>
      </CsTelText>
    </CsTelBox>
  );
}

const CsTelBox = styled.div`
  width: 100%;
  max-width: 430px;
  margin: 0 auto;
  height: 400px;
  background-color: #eef6f3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const CsHelpText = styled.div`
  margin-left: 24px;
  margin-right: 36px;
  p {
    font-size: 20px;
    font-weight: 400;
    line-height: 30px;
    &:last-child {
      font-size: 24px;
      font-weight: 700;
    }
  }
  @media ${({ theme: { mobile } }) => mobile} {
    margin-top: 16px;
    margin-bottom: 16px;
    margin-left: 0px;
    margin-right: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const CsTelText = styled.div`
  @media ${({ theme: { mobile } }) => mobile} {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const TextP1 = styled.a`
  font-size: 36px;
  font-weight: 700;
  line-height: 45px;
  color: #00b8c3;
  text-decoration: none;
`;

const TextP2 = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: #646464;
`; 